import React from "react";
import { Typography } from "antd";
import styles from "./teachers.module.css"; 
import TeacherViewTabs from "./components/teacher-view-tabs/teacher-view-tabs"; 
import TeachersStatisticsOverview from "./components/statistics-overview/statistics-overview";

const Teachers = () => {
  return (
    <div className={styles.teachers}>
      <Typography className={styles.title}>Teachers</Typography>
      <TeachersStatisticsOverview />
      <TeacherViewTabs />
    </div>
  );
};

export default Teachers;
